
import React, { Component } from 'react';
import { auth } from '../services/firebase';
import { db } from '../services/firebase';

export default class CancelNewChatBtn extends Component {
	constructor() {
		super();
        this.state = {
			user: auth().currentUser,
            error: null,
        };
		this.cancelNewChat = this.cancelNewChat.bind(this)
	}

    async cancelNewChat() {
        let chatRequestRef = db.ref('chat-requests').child("mentalhealth").child(this.state.user.uid)

        chatRequestRef.update({
            status: "canceled"
        });
    }

    render() {
        return (
            <button onClick={this.cancelNewChat} type='button' >
                cancel
            </button>
        );
    }
}
